import React from 'react';
import Video from './assets/ParroquiaToledo/Video.mp4';
const ParroquiaToledo = () => {
  return (
    <div className="container">
      <h2>
        ✅ Proyecto: Parroquia San Luis Gonzaga🌞✨
       
      </h2>
      <p>
                <video controls>
          <source src={Video} type="video/mp4" />
          Tu navegador no soporta la reproducción de video.
        </video>

 <span className='highlight'> Energía limpia al servicio de la comunidad y del compromiso ambiental de la Iglesia.</span>



<br/><br/>En la Parroquia San Luis Gonzaga, un espacio espiritual y de encuentro comunitario del municipio de Toledo Norde de Santander, instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 11.44 kWp, conformado por 16 paneles solares de alta eficiencia y un inversor multicanal de 10 kW.

<br/><br/>Gracias a esta implementación, la parroquia puede gestionar de manera eficiente y estable el consumo energético diario, garantizando energía continua para iluminación, equipos de sonido y apoyo a las actividades pastorales.

<br/><br/>Los objetivos de este proyecto fueron:<br/><br/>

✔ Reducir los costos asociados al consumo eléctrico de la parroquia.
<br/>✔ Implementar una solución sostenible que aporte al cuidado del medio ambiente.
<br/>✔ Garantizar energía constante para las actividades litúrgicas y comunitarias.

<br/><br/>Hoy, la Parroquia San Luis Gonzaga genera su propia energía limpia, disminuyendo los costos mensuales de facturación eléctrica y reflejando un compromiso real con la sostenibilidad.

<br/><br/>Con esta instalación, la parroquia no solo fortalece su misión espiritual, sino también su responsabilidad ambiental, siendo ejemplo para la comunidad de fe.

 <span className='highlight'><br/><br/>Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo: </span>

<br/><br/>🔧 Soporte técnico y mantenimiento preventivo
<br/>🔧 Monitoreo del sistema para garantizar máxima eficiencia energética
<br/>🔧 Instalación estructural segura, diseñada para prolongar la vida útil del sistema y facilitar su mantenimiento.
<br/>🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación

 <br/><br/><span className='highlight'>Una decisión inteligente que une ahorro, sostenibilidad y compromiso comunitario.</span>

      </p>
    </div>
  );
};

export default ParroquiaToledo;
